import { render, staticRenderFns } from "./assistDialog.vue?vue&type=template&id=22954f9d&scoped=true"
import script from "./assistDialog.vue?vue&type=script&lang=js"
export * from "./assistDialog.vue?vue&type=script&lang=js"
import style0 from "./assistDialog.vue?vue&type=style&index=0&id=22954f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22954f9d",
  null
  
)

export default component.exports